import React from 'react';
import {
  Box, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Typography, Button
} from '@material-ui/core';
import { AddCircle, ArrowBack, ArrowForward, Close, Info } from '@material-ui/icons';
import { avaliationDialogsActions } from '../../../actions';
import { HeaderTitle } from '../../EvaluationTeams/styles';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Upload, UploadButton, UploadStepFluxFiles } from '../../Upload';
import dialogPhotoSvg from '../../../assets/imgs/dialog-photo.svg';
import { dialogCss } from '../../CreateIdeaDialogs/dialogCss';

export const ImageDialog = () => {
  const dialogClasses = dialogCss();
  const { imageDialog } = useSelector(state => state.avaliationDialogs);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleClose = () => {
    dispatch(avaliationDialogsActions.openImageDialog());
  };

  const handlePrev = () => {
    dispatch(avaliationDialogsActions.openImageDialog());
    dispatch(avaliationDialogsActions.openAttachmentDialog());
  };

  const handleSave = () => {
    dispatch(avaliationDialogsActions.saveAttachments('imageRender', 'images'));
    handleClose();
  }


  return (
    <Dialog open={imageDialog} onClose={handleClose}>
      <DialogTitle disableTypography>
        <Box display='flex' justifyContent='space-between' alignItems='center'>
          <IconButton onClick={handlePrev}>
            <ArrowBack color='primary' />
          </IconButton>
          <HeaderTitle>{t('anexar_imagem')}</HeaderTitle>
          <IconButton onClick={handleClose}>
            <Close color='primary' />
          </IconButton>
        </Box>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <UploadStepFluxFiles
          type="photo"
          img={dialogPhotoSvg}
          name="foto"
          message={t('insira_uma_imagem_como_referencia_da_sua_qualificacao')}
          accept="image/png, image/jpeg"
          maxSize={5242880}
        />
      </DialogContent>
      <DialogActions className={dialogClasses.containerAction}>
        <Box style={{ width: '100%' }}>
          <Box display="flex" alignItems="center">
            <Info fontSize="small" style={{ marginRight: 6 }} />
            <Typography variant="caption">
              {t('o_arquivo_deve_ser_em_formato')}{' '}
              <strong>png</strong>{' '}{t('e')}{' '}
              <strong>jpg</strong> {' '}{t('e')}{' '}
              {t('possuir_tamanho_maximo_de')}{' '}<strong>5mb</strong>.
            </Typography>
          </Box>
          <Box marginTop={2} style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box></Box>
            <Button
              className={dialogClasses.button}
              variant="contained"
              color="primary"
              startIcon={<ArrowForward />}
              onClick={handleSave}
            >
              {t('salvar_anexo')}
            </Button>
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  );
}